import {ApiService} from "../../../api/api.service";
import {ADD_HISTORY_SUCCEEDED} from "../product.action";
import {FETCH_PRODUCTS_REQUESTED, FETCH_PRODUCTS_SUCCEEDED} from "../list/list.actions";
import {UtilityService} from "../../../common/services/utility/utility.service";
import {takeEvery, put, select} from "redux-saga/effects";
import {AppInjector} from "../../../app-injector";
import {API_CALL_ERROR} from "../../../store/action";
import {
  CREATE_GHOST_PRODUCTS_COMPLETED,
  CREATE_GHOST_PRODUCTS_REQUESTED, CREATE_GHOST_PRODUCTS_SUCCEEDED,
  LIST_GHOST_PRODUCTS_REQUESTED,
  LIST_GHOST_PRODUCTS_SUCCEEDED, PRINT_GHOST_PRODUCT_COMPLETED,
  PRINT_GHOST_PRODUCT_REQUESTED, PRINT_GHOST_PRODUCT_SUCCEEDED
} from "./ghost.actions";
import { PRINT_COMPLETED, PRINT_REQUEST} from "../../../store/print/print.actions";
import {BarcodeComponent} from "../../../common/print-template/product-barcode/barcode.component";
import store from "../../../store/store.module";

function* getGhostProducts() {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.asyncProcess.getAllGhostProducts().toPromise();
    yield put({ type: LIST_GHOST_PRODUCTS_SUCCEEDED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetGhostProductsRequested() {
  yield takeEvery(LIST_GHOST_PRODUCTS_REQUESTED, getGhostProducts);
}

function* printGhostProducts(data) {
  yield put({ type: PRINT_REQUEST, data: { values: data.skus }, component: BarcodeComponent });
}

function* watchPrintGhostProductsRequested() {
  yield takeEvery(PRINT_GHOST_PRODUCT_REQUESTED, printGhostProducts);
}

function* afterPrintGhostProductsCompleted() {
  const data = yield select(state => (state as any).Product.ghost.printData);
  if (data) {
    const api = AppInjector.get(ApiService);
    try {
      yield api.product.printGhostProduct(data).toPromise();
      let results = yield api.asyncProcess.getAllGhostProducts().toPromise();
      yield put({ type: PRINT_GHOST_PRODUCT_SUCCEEDED, data: results });
    } catch (e) {
      yield put({ type: API_CALL_ERROR, error: e });
    }
  }
}

function* watchAfterPrintGhostProductsCompleted() {
  yield takeEvery(PRINT_GHOST_PRODUCT_COMPLETED, afterPrintGhostProductsCompleted);
}

function* createGhostProducts(data) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.product.createGhostProduct(data.data).toPromise();
    yield put({ type: CREATE_GHOST_PRODUCTS_SUCCEEDED, data: result.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCreateGhostProductsRequested() {
  yield takeEvery(CREATE_GHOST_PRODUCTS_REQUESTED, createGhostProducts);
}

export default [
  watchGetGhostProductsRequested,
  watchCreateGhostProductsRequested,
  watchPrintGhostProductsRequested,
  watchAfterPrintGhostProductsCompleted
];
